import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChange } from "../../generalReducer/action/GlobalAction";

const MainpageHook = () => {
  const [loading, setLoading] = useState(false);
  const [routes, setRoutes] = useState("/");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLoading = (route) => {
    let newRoute = route;
    dispatch(handleChange({ newRoute }));
    navigate("/loading");
    console.log(newRoute);
  };

  return { handleLoading, loading, setLoading, routes };
};

export default MainpageHook;
